/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Custom_Name_LabelInputs */

const en_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Name`)
};

const fr_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom personnalise`)
};

const de_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierter Name`)
};

const it_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome personalizzato`)
};

const ru_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательское имя`)
};

const es_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre personalizado`)
};

const zh_cn2_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义名称`)
};

const ja_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム名`)
};

const hi_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रचलित नाम`)
};

const pt_pt2_embed_captions_custom_name_label = /** @type {(inputs: Embed_Captions_Custom_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome personalizado`)
};

/**
* | output |
* | --- |
* | "Custom Name" |
*
* @param {Embed_Captions_Custom_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_custom_name_label = /** @type {((inputs?: Embed_Captions_Custom_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Custom_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_custom_name_label(inputs)
	if (locale === "de") return de_embed_captions_custom_name_label(inputs)
	if (locale === "it") return it_embed_captions_custom_name_label(inputs)
	if (locale === "ru") return ru_embed_captions_custom_name_label(inputs)
	if (locale === "es") return es_embed_captions_custom_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_custom_name_label(inputs)
	if (locale === "ja") return ja_embed_captions_custom_name_label(inputs)
	if (locale === "hi") return hi_embed_captions_custom_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_custom_name_label(inputs)
	return en_embed_captions_custom_name_label(inputs)
});